"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dollars = exports.FINANCE_KEYS = void 0;
exports.financeValues = financeValues;
/**
 * The finance provider's key space.
 *
 * Adding a key here and not producing it in `financeValues` is a COMPILE
 * ERROR (that function `satisfies Record<FinanceKey, string | undefined>`).
 */
exports.FINANCE_KEYS = [
    'term_months', 'payment_amount', 'deposit_amount', 'buyout_amount',
    'first_payment_date', 'total_of_payments', 'early_payoff_terms', 'default_terms',
];
const dollars = (cents) => `$${(cents / 100).toFixed(2)}`;
exports.dollars = dollars;
function financeValues(skus) {
    const monthly = skus.filter(s => s.interval === 'month');
    const monthlyTotal = monthly.reduce((sum, s) => sum + s.amountCents * s.quantity, 0);
    const termMonths = monthly.reduce((max, s) => Math.max(max, s.termMonths ?? 0), 0);
    /**
     * An open-ended rental's only truthful total is its MINIMUM COMMITMENT
     * (0 when uncommitted). A one-time add-on riding along contributes its own
     * one-time total. Carried verbatim from billing-service onboarding.ts.
     */
    const total = skus.reduce((sum, s) => {
        const own = s.interval !== 'month'
            ? s.amountCents
            : typeof s.termMonths === 'number'
                ? s.amountCents * s.termMonths
                : s.amountCents * (s.minCommitmentMonths ?? 0);
        return sum + own * s.quantity;
    }, 0);
    const deposit = skus.reduce((sum, s) => sum + (s.depositCents ?? 0) * s.quantity, 0);
    const buyout = skus.reduce((sum, s) => sum + (s.buyoutCents ?? 0) * s.quantity, 0);
    return {
        term_months: termMonths > 0 ? String(termMonths) : undefined,
        payment_amount: monthly.length ? (0, exports.dollars)(monthlyTotal) : undefined,
        // Emits '$0.00' directly when no SKU carries a deposit. The catalog declares
        // a literal '$0.00' fallback for this field, but NOTHING evaluates fallbacks
        // yet — documents-render has no fallback engine — so returning undefined here
        // would throw MissingMergeFieldError on every zero-deposit deal. Revisit once
        // documents-render implements fallback chains.
        deposit_amount: (0, exports.dollars)(deposit),
        buyout_amount: buyout > 0 ? (0, exports.dollars)(buyout) : undefined,
        first_payment_date: skus.find(s => s.firstPaymentDate)?.firstPaymentDate,
        total_of_payments: (0, exports.dollars)(total),
        early_payoff_terms: skus.find(s => s.earlyPayoffTerms)?.earlyPayoffTerms,
        default_terms: skus.find(s => s.defaultTerms)?.defaultTerms,
    };
}
//# sourceMappingURL=finance.js.map